<ng-template #proofAmountSummary>
  <ng-container
    *ngIf="
      finalAmount !== null && finalAmount !== undefined;
      else proofAmountFallback
    "
  >
    <gatewee-amount-fee-breakdown
      class="gw-w-full"
      [amount]="amount"
      [calculatedFee]="calculatedFee"
      [finalAmount]="finalAmount"
      inputMode="addFees"
      variant="compact"
    ></gatewee-amount-fee-breakdown>
  </ng-container>
  <ng-template #proofAmountFallback>
    <div class="gw-flex gw-flex-col">
      <p class="gw-text-text-secondary gw-text-base gw-m-0 gw-font-normal">
        {{ 'features.withdrawals.modalBankSlip.boletoAmount' | translate }}
      </p>
      <p class="gw-text-text-primary gw-text-base gw-font-extrabold gw-m-0">
        {{ validated?.amount | currency : 'BRL' }}
      </p>
    </div>
  </ng-template>
</ng-template>

<ng-container *ngIf="isWithdrawalPolling">
  <div
    class="gw-flex gw-flex-col gw-items-center gw-text-center gw-gap-small gw-mb-medium"
  >
    <gatewee-icon
      icon="@phi.clock"
      class="gw-text-status-warning gw-shrink-0"
      size="44px"
    ></gatewee-icon>
    <span
      class="gw-text-center gw-text-text-primary gw-text-[16px] gw-font-extrabold"
    >
      {{ 'features.withdrawals.modalBankSlip.paymentPending' | translate }}
    </span>
    <p
      class="gw-text-center gw-text-text-secondary gw-text-base gw-m-0 gw-max-w-[280px]"
    >
      {{
        'features.withdrawals.modalBankSlip.paymentPendingSummary' | translate
      }}
    </p>
  </div>
  <div
    class="gw-flex gw-flex-col gw-rounded-[24px] gw-p-medium gw-bg-background-elevation-1 gw-mb-x-large gw-border-base gw-items-start gw-gap-small"
  >
    <ng-container *ngTemplateOutlet="proofAmountSummary"></ng-container>
    <div class="gw-h-px gw-w-full gw-bg-border-normal" aria-hidden="true"></div>
    <div class="gw-flex gw-flex-col">
      <p class="gw-text-text-secondary gw-text-base gw-m-0">
        {{ 'features.withdrawals.modalBankSlip.proofMethod' | translate }}
      </p>
      <p class="gw-text-text-primary gw-text-base gw-font-extrabold gw-m-0">
        {{ beneficiaryName | uppercase }}
      </p>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="isWithdrawalSuccess">
  <div class="gw-flex gw-items-center gw-gap-small gw-mb-medium">
    <gatewee-icon
      icon="@phi.check-circle"
      class="gw-text-status-info gw-shrink-0"
      size="44px"
    ></gatewee-icon>
    <div class="gw-flex gw-flex-col">
      <span class="gw-text-text-primary gw-text-[16px] gw-font-extrabold">
        {{ 'features.withdrawals.modalBankSlip.paymentSuccess' | translate }}
      </span>
      <p class="gw-text-text-secondary gw-text-base gw-m-0">
        {{
          'features.withdrawals.modalBankSlip.paymentSuccessSummary' | translate
        }}
      </p>
    </div>
  </div>

  <div
    class="gw-flex gw-flex-col gw-rounded-[24px] gw-p-medium gw-bg-background-elevation-1 gw-mb-x-large gw-border-base gw-items-start gw-gap-small"
  >
    <ng-container *ngTemplateOutlet="proofAmountSummary"></ng-container>

    <div class="gw-h-px gw-w-full gw-bg-border-normal" aria-hidden="true"></div>

    <div class="gw-flex gw-flex-col" *ngIf="beneficiaryName">
      <span
        class="gw-text-text-primary gw-text-base gw-font-medium gw-mb-medium"
      >
        {{ 'features.withdrawals.modalBankSlip.payingTo' | translate }}
      </span>
      <p class="gw-text-text-primary gw-font-extrabold gw-m-0">
        {{ beneficiaryName | uppercase }}
      </p>
    </div>

    <div
      class="gw-h-px gw-w-full gw-bg-border-normal gw-mt-medium"
      aria-hidden="true"
      *ngIf="beneficiaryName"
    ></div>

    <span class="gw-text-text-primary gw-text-base gw-font-medium gw-mb-small">
      {{ 'features.withdrawals.modalBankSlip.details' | translate }}
    </span>

    <div
      class="gw-flex gw-w-full gw-items-center gw-justify-between"
      *ngIf="beneficiaryDocument"
    >
      <span class="gw-text-text-primary gw-font-extrabold">
        {{ 'features.withdrawals.modalBankSlip.cpfCnpj' | translate }}
      </span>
      <span class="gw-text-text-secondary">
        {{ beneficiaryDocument | document }}
      </span>
    </div>

    <div
      class="gw-flex gw-w-full gw-items-start gw-justify-between gw-gap-small"
      *ngIf="digitableLine"
    >
      <span class="gw-text-text-primary gw-font-extrabold gw-shrink-0">
        {{ 'features.withdrawals.modalBankSlip.digitableLabel' | translate }}
      </span>
      <span
        class="gw-max-w-[60%] gw-break-all gw-text-right gw-text-text-secondary gw-font-mono gw-tabular-nums"
      >
        {{ digitableLine }}
      </span>
    </div>

    <div
      class="gw-flex gw-w-full gw-items-center gw-justify-between"
      *ngIf="paymentReceipt?.id"
    >
      <span class="gw-text-text-primary gw-font-extrabold">
        {{
          'features.withdrawals.modalBankSlip.proofTransactionId' | translate
        }}
      </span>
      <span class="gw-text-text-secondary gw-break-all">
        {{ paymentReceipt?.id }}
      </span>
    </div>

    <div
      class="gw-flex gw-w-full gw-items-center gw-justify-between"
      *ngIf="paymentReceipt?.e2eId"
    >
      <span class="gw-text-text-primary gw-font-extrabold">
        {{ 'common.paymentReceipt.e2eId' | translate }}
      </span>
      <span class="gw-text-text-secondary gw-break-all">
        {{ paymentReceipt?.e2eId }}
      </span>
    </div>

    <div
      class="gw-flex gw-w-full gw-items-center gw-justify-between"
      *ngIf="paymentReceipt?.date"
    >
      <span class="gw-text-text-primary gw-font-extrabold">
        {{ 'common.paymentReceipt.date' | translate }}
      </span>
      <span class="gw-text-text-secondary">
        {{ paymentReceipt?.date | date : 'dd/MM/yyyy HH:mm' }}
      </span>
    </div>

    <div
      class="gw-h-px gw-w-full gw-bg-border-normal gw-mt-medium"
      aria-hidden="true"
    ></div>

    <div class="gw-flex gw-flex-col">
      <p class="gw-text-text-secondary gw-text-base gw-m-0">
        {{ 'features.withdrawals.modalBankSlip.proofVia' | translate }}
      </p>
      <p class="gw-text-text-primary gw-text-base gw-font-extrabold gw-m-0">
        {{ 'features.withdrawals.modalBankSlip.proofMethod' | translate }}
      </p>
    </div>
    <div class="gw-flex gw-flex-col" *ngIf="paymentMetadata?.provider">
      <p class="gw-text-text-secondary gw-text-base gw-m-0">
        {{ 'features.withdrawals.modalBankSlip.provider' | translate }}
      </p>
      <p class="gw-text-text-primary gw-text-base gw-font-extrabold gw-m-0">
        {{ paymentMetadata?.provider | provider }}
      </p>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="isWithdrawalFailed">
  <div class="gw-flex gw-items-center gw-gap-small gw-mb-medium">
    <gatewee-icon
      icon="@phi.x-circle"
      class="gw-text-status-negative gw-shrink-0"
      size="44px"
    ></gatewee-icon>
    <div class="gw-flex gw-flex-col">
      <span class="gw-text-text-primary gw-text-[16px] gw-font-extrabold">
        {{ 'features.withdrawals.modalBankSlip.paymentFailed' | translate }}
      </span>
      <p class="gw-text-text-secondary gw-text-base gw-m-0">
        <ng-container *ngIf="statusErrorMessage; else failedSummary">
          {{ statusErrorMessage }}
        </ng-container>
        <ng-template #failedSummary>
          {{
            'features.withdrawals.modalBankSlip.paymentFailedSummary'
              | translate
          }}
        </ng-template>
      </p>
    </div>
  </div>
  <div
    class="gw-flex gw-flex-col gw-rounded-[24px] gw-p-medium gw-bg-background-elevation-1 gw-mb-x-large gw-border-base gw-items-start gw-gap-small"
  >
    <ng-container *ngTemplateOutlet="proofAmountSummary"></ng-container>
    <div class="gw-h-px gw-w-full gw-bg-border-normal" aria-hidden="true"></div>
    <div class="gw-flex gw-flex-col">
      <p class="gw-text-text-secondary gw-text-base gw-m-0">
        {{ 'features.withdrawals.modalBankSlip.proofMethod' | translate }}
      </p>
      <p class="gw-text-text-primary gw-text-base gw-font-extrabold gw-m-0">
        {{ beneficiaryName | uppercase }}
      </p>
    </div>
  </div>
</ng-container>
